import Vue from 'vue'
import _ from 'lodash'
const state = {
  enableSearch: false,
  selected_group_id: null,
  unread: false,
  outbound: false,
  inbound: false,
  user_attribute_id: 0,
  box: 'general',
  search_text: '',
  platforms: [],
  labels: [],
  admins: [],
  tags: [],
  case_statuses: [],
  dates: {
    updatedAt: null,
    updatedAtEnd: null
  }
}

// functions receive state
const getters = {
  searchIsEnabled(state) {
    return state.enableSearch
  },
  unreadValue(state) {
    return state.unread
  },
  updatedAtValue(state) {
    return state.dates.updatedAt
  },
  updatedAtEndValue(state) {
    return state.dates.updatedAtEnd
  },
  outboundValue(state) {
    return state.outbound
  },
  inboundValue(state) {
    return state.inbound
  },
  boxValue(state) {
    return state.box
  },
  platformsNames(state) {
    return state.platforms.map((p) => p.name).join(',')
  },
  labelsIds(state) {
    return state.labels.map((f) => f.label_id).join(',')
  },
  tagsIds(state) {
    return state.tags.map((f) => f.tag_id).join(',')
  },
  adminsIds(state) {
    return state.admins.map((f) => f.admin_id).join(',')
  },
  searchText(state) {
    return state.search_text
  },
  statusValues(state) {
    return state.case_statuses.join(',')
  },
  userAttributeId(state) {
    return state.user_attribute_id
  },
  filtersCount(state) {
    let count = 0

    if (state.box !== 'general') count++
    if (state.dates.updatedAt && state.dates.updatedAtEnd) count++

    const _filterCount = [
      'unread',
      'outbound',
      'inbound',
      'search_text',
      'enableSearch'
    ].reduce((acc, el) => {
      if (state[el]) acc++
      return acc
    }, 0)
    count += _filterCount

    for (const el of [
      'platforms',
      'admins',
      'labels',
      'tags',
      'case_statuses'
    ]) {
      count += state[el].length
    }

    return count
  }
}

// functions receive context and params
const actions = {}

// functions receive state
const mutations = {
  setGroupId(state, groupId) {
    state.selected_group_id = groupId
  },
  setPlatforms(state, platforms) {
    state.platforms = platforms
  },
  removePlatform(state, name) {
    const index = state.platforms.findIndex((p) => p.name === name)
    if (index >= 0) {
      state.platforms.splice(index, 1)
    }
  },
  setLabels(state, labels) {
    state.labels = _.isArray(labels)
      ? labels
      : labels.split(',').filter(Boolean)
  },
  setTags(state, tags) {
    state.tags = _.isArray(tags) ? tags : tags.split(',').filter(Boolean)
  },
  setOnlyLabels(state, labels) {
    state.labels = labels
  },
  setOnlyTags(state, tags) {
    state.tags = tags
  },
  setAdmins(state, admins) {
    state.admins = admins
  },
  removeAdmin(state, adminId) {
    const index = state.admins.findIndex((a) => a.admin_id === adminId)
    if (index >= 0) {
      state.admins.splice(index, 1)
    }
  },
  setBox(state, box) {
    state.box = box
  },
  setUnread(state, unread) {
    state.unread = unread
  },
  setOutbound(state, outbound) {
    state.outbound = outbound
  },
  setInbound(state, inbound) {
    state.inbound = inbound
  },
  setCaseStatus(state, status) {
    const index = state.case_statuses.findIndex((s) => s === status.value)

    if (!status.event) {
      if (index >= 0) state.case_statuses.splice(index, 1)
    } else {
      if (index < 0) state.case_statuses.push(status.value)
    }
  },
  setDates(state, dates) {
    state.dates.updatedAt = dates
      ? Vue.prototype.$moment(dates.startDate).format('YYYY-MM-DD')
      : null
    state.dates.updatedAtEnd = dates
      ? Vue.prototype.$moment(dates.endDate).format('YYYY-MM-DD')
      : null
  },
  setSearchText(state, text) {
    state.search_text = text
  },
  setUserAttributeId(state, val) {
    state.user_attribute_id = val
  },
  enableSearch(state, val) {
    state.enableSearch = val
  },
  resetAllFilters(state) {
    state.enableSearch = false
    state.unread = false
    state.outbound = false
    state.inbound = false
    state.user_attribute_id = 0
    state.box = 'general'
    state.search_text = ''
    state.platforms = []
    state.labels = []
    state.admins = []
    state.tags = []
    state.case_statuses = []
    state.dates.updatedAt = state.dates.updatedAtEnd = null
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
